var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button, EmptyState, EmptyStateBody, EmptyStateFooter, EmptyStateHeader, EmptyStateVariant } from '@patternfly/react-core';
import NotFoundIcon from '../NotFoundIcon/NotFoundIcon';
import React from 'react';
const InvalidObject = (_a) => {
    var { toHomePageUrl = window.location.origin, toHomePageText = 'Return to homepage', invalidObjectTitleText = 'We lost that page', invalidObjectBodyText = "Let's find you a new one. Try a new search or return home.", ouiaId = "InvalidObject" } = _a, props = __rest(_a, ["toHomePageUrl", "toHomePageText", "invalidObjectTitleText", "invalidObjectBodyText", "ouiaId"]);
    return (React.createElement(EmptyState, Object.assign({ variant: EmptyStateVariant.full, "data-ouia-component-id": ouiaId }, props),
        React.createElement(EmptyStateHeader, { titleText: invalidObjectTitleText, icon: React.createElement(NotFoundIcon, { "data-ouia-component-id": `${ouiaId}-icon` }), headingLevel: 'h1', "data-ouia-component-id": `${ouiaId}-header` }),
        React.createElement(EmptyStateBody, { "data-ouia-component-id": `${ouiaId}-body` }, invalidObjectBodyText),
        React.createElement(EmptyStateFooter, { "data-ouia-component-id": `${ouiaId}-footer` },
            React.createElement(Button, { variant: "link", component: "a", href: toHomePageUrl, ouiaId: `${ouiaId}-home-button` }, toHomePageText))));
};
export default InvalidObject;
